import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  filter: "createdOn",
  filterType: "date",
  sort: "createdOn"
}
const _hoisted_2 = {
  filter: "user.name",
  sort: "user.name"
}
const _hoisted_3 = {
  filter: "signedOn",
  filterType: "date",
  sort: "signedOn"
}
const _hoisted_4 = {
  filter: "rejectedOn",
  filterType: "date",
  sort: "rejectedOn"
}
const _hoisted_5 = {
  filter: "approvedOn",
  filterType: "date",
  sort: "approvedOn"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { width: "200" }, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { colspan: "99" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.contratti
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_1, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data creazione",
                text: "Data creazione"
              })
            ]),
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_component_localized_text, {
                localizedKey: "Utente",
                text: "Utente"
              })
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Contratti",
                text: "Contratti"
              })
            ]),
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data firma",
                text: "Data firma"
              })
            ]),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data rifiuto",
                text: "Data rifiuto"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data approvazione",
                text: "Data approvazione"
              })
            ]),
            _hoisted_6
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                _createElementVNode("td", _hoisted_8, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.items as OM.ContrattoCollaborazione[]), (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn)), 1),
              _createElementVNode("td", null, [
                _createElementVNode("a", {
                  href: '#/lead/detail/' + item.user.identifier
                }, _toDisplayString(item.user.name), 9, _hoisted_9)
              ]),
              _createElementVNode("td", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.signedDocumentAttachment, (x, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    _createElementVNode("a", {
                      href: x.publicUrl,
                      target: "_blank"
                    }, _toDisplayString(x.fileName), 9, _hoisted_10)
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.signedDocumentUrl, (url, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    _createElementVNode("a", {
                      href: url,
                      target: "_blank"
                    }, "Visualizza contratto " + _toDisplayString(i + 1), 9, _hoisted_11)
                  ]))
                }), 128))
              ]),
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.signedOn, "YYYY MMMM DD HH:MM")), 1),
              _createElementVNode("td", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$filters.date(item.rejectedOn, "YYYY MMMM DD HH:MM")), 1)
              ]),
              _createElementVNode("td", null, [
                (!item.approvedOn && !item.rejectedOn)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Non ancora approvato",
                        text: "Non ancora approvato"
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$filters.date(item.approvedOn, "YYYY MMMM DD HH:MM")), 1))
              ]),
              _createElementVNode("td", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-primary",
                  onClick: ($event: any) => (_ctx.commenti(item))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Apri commenti",
                    text: "Apri commenti"
                  }),
                  (item.comments.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("(" + _toDisplayString(item.comments.length) + ")", 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_localized_text, {
                    localizedKey: "e allegati",
                    text: "e allegati"
                  }),
                  (item.attachments.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("(" + _toDisplayString(item.attachments.length) + ")", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_15),
                _hoisted_16,
                (!item.approvedOn && !item.rejectedOn)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-sm btn-green mt-1",
                      onClick: ($event: any) => (_ctx.approve(item))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Approva",
                        text: "Approva"
                      })
                    ], 8, _hoisted_17))
                  : _createCommentVNode("", true),
                _hoisted_18,
                (!item.approvedOn && !item.rejectedOn)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-sm btn-danger mt-1",
                      onClick: ($event: any) => (_ctx.respingi(item))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Respingi",
                        text: "Respingi"
                      })
                    ], 8, _hoisted_19))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items"])
  ]))
}